export default __webpack_public_path__ + "static/media/f25-banner.19f24d98.jpg";